import { useCallback, useEffect, useState } from 'react';
import { VStack, Text } from '@cad-arc';
import { SubjectStopForm, AttributeOption } from '@mark43/cad-api';
import { CheckboxMultiselect } from '../common/components/checkbox-multiselect';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrEventSubjectDataCheckboxesMultiselectField({
    title,
    name,
    options,
    index,
    selectedOptions,
}: {
    title: string;
    name: keyof SubjectStopForm['subjectDataForms'][0];
    options: AttributeOption[];
    index: number;
    selectedOptions: AttributeOption[];
}) {
    const { form, isSubmitting } = useIntegratedForm<SubjectStopForm>();
    const [selectedOptionsIds, setSelectedFieldOptionsIds] = useState<number[]>([]);

    useEffect(() => {
        if (selectedOptions) {
            setSelectedFieldOptionsIds(
                selectedOptions.map((selectedFieldValue) => selectedFieldValue.value)
            );
        } else {
            setSelectedFieldOptionsIds([]);
        }
    }, [selectedOptions]);

    const handleChange = useCallback(
        (value: (string | number)[]) => {
            const newSelectedOptionsIds = value.map(Number);
            const optionsIdsToAdd = newSelectedOptionsIds.filter(
                (optionId) => !selectedOptionsIds.includes(optionId)
            );
            const optionsToAdd = options.filter((option) => optionsIdsToAdd.includes(option.value));
            const newOptions = [...selectedOptions, ...optionsToAdd].filter((label) =>
                newSelectedOptionsIds.includes(label.value)
            );

            form.setValue(`subjectDataForms.${index}.${name}`, newOptions);
        },
        [selectedOptionsIds, selectedOptions, options, form, index, name]
    );

    return (
        <VStack width="100%" alignItems="flex-start" gap={1} style={{ marginTop: 25 }}>
            <VStack width="100%" alignItems="flex-start" gap={0}>
                <Text>
                    {title}
                    <Text as="span" color="negative">
                        {' *'}
                    </Text>
                </Text>
                <Text style={{ marginTop: 0 }} fontSize="sm" color="tertiary">
                    Select at least 1
                </Text>
            </VStack>
            <CheckboxMultiselect
                value={selectedOptionsIds}
                onChange={handleChange}
                options={options}
                columns={1}
                isReadOnly={isSubmitting}
            />
        </VStack>
    );
}
